import React from "react";
import { View } from "ui";
import Menu from "pages/Menu";
import { appQueries } from "api";
import { Route, RouteComponentProps, Switch, Redirect } from "react-router";
import { Query, DataProps } from "types";
import _ from "lodash";
import { AppColumns } from "./components/AppColumns";

import Memos from "./Memos";
import Alerts from "./Alerts";
import AlertForm from "../main/AlertForm";
import EditMemo from "../../pages/EditMemo";
import Settings from "../../pages/Settings";
import Contact from "../../pages/Contact";
import Payment from "../../pages/Payment";
import Faq from "../../pages/Faq";
import TermsOfService from "../../pages/TermsOfService";
import UserPage from "../../pages/UserPage";
import BillingInfo from "../../pages/BillingInfo";
import { POLL_INTERVAL } from "shared/constants";
import Presentation from "../../pages/Presentation";
import PresentationModal from "../../pages/PresentationModal";
import { link } from "fs";
import { History } from "history";
import { ApolloError } from 'apollo-client';
import { connect } from 'react-redux';
import { Actions } from 'store';

const createDataProp = _.memoize((data: Query) => {
  const prop: DataProps = {
    ...data,
    findMemoIndex: id => _.findIndex(data.memos, { id }),
    findMemoById: id => _.find(data.memos, { id }),
    findTemplateById: id =>
      _.find(_.flatMap(data.categories, c => c.templates), { id }),
    findAlertById: id => _.find(data.alerts, { id }),
    findMemoAlerts: memo_id => _.filter(data.alerts, { memo_id }),
    findMemoPhotos: memo_id => _.filter(data.memoPhotos, { memo_id })
  };
  return prop;
});

 class App extends React.Component<RouteComponentProps & any>{
  handleError = (error: ApolloError) => {
    if(error.networkError && (error.networkError as any).statusCode && (error.networkError as any).statusCode === 500){
      this.props.setToken('')
      setTimeout(() => {
        this.props.history.replace('/')
      })
    }
  }
  render(){
    const { match } = this.props;
      return (
        <appQueries.AppData onError={this.handleError} pollInterval={POLL_INTERVAL}>
          {({ loading, data, error }) => {
            if (loading) {
              return null;
            }
            if (error) {
              return <View>error</View>;
            }
            const prop = createDataProp(data);
            return (
              <View flexDirection="row" bg="bggray">
                <View
                  flex={1}
                  minWidth={250}
                  maxWidth={250}
                  flexDirection="row"
                  justifyContent="stretch"
                  alignItems="stretch"
                >
                  <Menu />
                </View>
                <View flex={10} flexDirection="column" alignItems="stretch">
                  <Switch>
                    <Route
                      path={`${match.path}/memos/:memo_id/alert/:alert_id`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={
                            <EditMemo
                              key={routeProps.match.params.memo_id}
                              {...prop}
                              {...routeProps}
                            />
                          }
                          rightColumn={
                            <AlertForm
                              key={routeProps.match.params.alert_id}
                              {...routeProps}
                              {...prop}
                            />
                          }
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/memos/:memo_id/alert/`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={
                            <EditMemo
                              key={routeProps.match.params.memo_id}
                              {...prop}
                              {...routeProps}
                            />
                          }
                          rightColumn={
                            <AlertForm
                              key={`new-alert-${routeProps.location.search}`}
                              {...routeProps}
                              {...prop}
                            />
                          }
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/memos/:memo_id`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Memos {...prop} {...routeProps} />}
                          rightColumn={
                            <EditMemo
                              key={routeProps.match.params.memo_id}
                              {...prop}
                              {...routeProps}
                            />
                          }
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/memos`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Memos {...prop} {...routeProps} />}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/settings`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Settings {...prop} {...routeProps} />}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/faq`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Faq {...prop} {...routeProps} />}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/tos`}
                      render={routeProps => (
                        <TermsOfService {...prop} {...routeProps} />
                      )}
                    />
                    <Route
                      path={`${match.path}/contact`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Contact {...prop} {...routeProps} />}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/cumpara/plata`}
                      render={routeProps => <AppColumns leftColumn={<Payment {...prop} {...routeProps} />} />}
                    />
    
                    <Route
                      path={`${match.path}/cumpara`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<BillingInfo {...prop} {...routeProps} />}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/prezentare`}
                      render={history => (
                        <PresentationModal
                          open={true}
                          onClose={() => {
                            history.history.replace("/app");
                          }}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/abonament`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<UserPage {...prop} {...routeProps} />}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/alerts/:alert_id`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Alerts {...prop} {...routeProps} />}
                          rightColumn={
                            <AlertForm
                              fromAlerts
                              key={routeProps.match.params.alert_id}
                              {...routeProps}
                              {...prop}
                            />
                          }
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}/alerts/new`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Alerts {...prop} {...routeProps} />}
                          rightColumn={
                            <AlertForm key="new-alert" {...routeProps} {...prop} />}
                        />
                      )}
                    />
    
                    <Route
                      path={`${match.path}/alerts`}
                      render={routeProps => (
                        <AppColumns
                          leftColumn={<Alerts {...prop} {...routeProps} />}
                        />
                      )}
                    />
                    <Route
                      path={`${match.path}`}
                      render={() => <Redirect to={`${match.path}/alerts`} />}
                    />
                  </Switch>
                </View>
              </View>
            );
          }}
        </appQueries.AppData>
      );
    };
    
  
}
export default connect(state => ({ ...state }), {
  setToken: Actions.setToken
})(App)


// WEBPACK FOOTER //
// ./src/routes/main/App.tsx